<textarea pInputTextarea
	[formControl]="formControl"
	[formlyAttributes]="field"
	[rows]="field.props.rows"
	[autoResize]="field.props.autoResize">
</textarea>

<field-validation-message
	[field]="field">
</field-validation-message>